export default __webpack_public_path__ + "static/media/payment_activated.3a708ac9.svg";